import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-network-recycling-facilities-filters',
  templateUrl: './network-recycling-facilities-filters.component.html',
  styleUrls: ['./network-recycling-facilities-filters.component.scss']
})
export class NetworkRecyclingFacilitiesFiltersComponent implements OnInit {

  @Input()
  years!: number[];

  searchForm = this.formBuilder.group({
    year: [''],
    order: ['desc'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({year: this.yearControl.value, order: this.orderControl.value} as IntelligenceSearchInterface);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.orderControl.setValue(null);
    this.search.emit({year: this.yearControl.value} as IntelligenceSearchInterface);
  }

}
